import React, { Component } from "react";
import axios from "axios";
import qs from "qs";
import Header from "../components/Header/Header";
import Cookies from "js-cookie";
import ContinueShopping from "../components/ContinueShopping/ContinueShopping";
import BagItem from "../components/BagItem/BagItem";
import BagSummary from "../components/BagSummary/BagSummary";
import CartMessaging from "../components/CartMessaging/CartMessaging";
import CheckoutPageError from "../components/CheckoutPageError/CheckoutPageError";
import Modal from "../components/Modal/Modal";
import Loader from "../components/Loader/Loader";
import * as GlobalStyle from "../CSSStyles";
import warningIcon from "./../assets/images/icons/ic_warning.svg";
import emptyBagIcon from "./../assets/images/icons/ic_empty_bag.svg";

const gtmId = "GTM-MXMG453";

class Bag extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.cameFromBagPage();
    this.props.currentPage("bag");

    this.props.resetOrderDetailsOnLoadGTM(); // to be able to rerun onload GTM on Checkout Page when user returns to Bag Page
    this.props.getBagAPI();
  }

  signInLinkClick = () => {
    this.setCookies("/checkout/#" + this.props.data.bagPagePath);
  };
  createLinkClick = () => {
    this.setCookies("/checkout/#" + this.props.data.bagPagePath);
  };
  signInCheckoutLinkClick = () => {
    this.setCookies("/checkout/#" + this.props.data.checkoutPagePath);
  };
  setCookies = (e) => {
    Cookies.set("customRedirect", e);
  };
  getRememberMeStatus = (res) => {
    var remember = false;
    /* Pull remember me status from the group context */
    if (typeof res.groupContext !== "undefined") {
      var groupRemember = JSON.parse(res.groupContext).remember;
      if (typeof groupRemember !== "undefined") {
        remember = groupRemember;
      }
    }
    /* "Remember Me" clicked on the current site always overrides the group context remember */
    if (typeof res.remember !== "undefined") {
      remember = res.remember;
    }
    return remember;
  };
  signInPOC = () => {
    window.gigya.accounts.showScreenSet({
      screenSet: "CamOrg-RegistrationLogin",
      startScreen: "gigya-login-screen",
      containerID: "loginScreenDiv",
      onError: function (e) {
        console.error(e);
      },
    });
    window.gigya.socialize.addEventHandlers({
      onLogin: (event) => {
        console.log(event, "event");
        var remember = this.getRememberMeStatus(event);

        // /tools/packages/gigya/c5SignInFromGigya
        axios({
          method: "post",
          url: "/tools/packages/gigya/c5SignInFromGigya",
          data: qs.stringify({ data: event }),
          headers: {
            "X-requested-with": "XMLHttpRequest",
          },
        })
          .then((response) => {
            console.log(response, "c5SignInFromGigya response");
            var success = response.data.success;
            var data = {
              uid: event.UID,
              uid_sig: event.UIDSignature,
              sig_timestamp: event.signatureTimestamp,
              remember: remember,
              page_redirect: "/checkout",
            };

            // /gigya/raas-login

            axios({
              method: "post",
              url: "/gigya/raas-login",
              data: qs.stringify(data),
              headers: {
                "content-type":
                  "application/x-www-form-urlencoded;charset=utf-8",
              },
            })
              .then((response) => {
                console.log(response, "raas-login response");
                // /gigya/konakart/login

                var data_kk = {
                  firstName: event.user.firstName, // res is from login handler
                  lastName: event.user.lastName,
                  email: event.user.email,
                  countryCode: event.user.country,
                };
                axios({
                  method: "post",
                  url: "/gigya/konakart/login",
                  data: qs.stringify(data_kk),
                  headers: {
                    "content-type":
                      "application/x-www-form-urlencoded;charset=utf-8",
                  },
                })
                  .then((response) => {
                    console.log(response, "/login response");
                    if (success) {
                      window.location.reload();
                    }
                  })
                  .catch((error) => {});
              })
              .catch((error) => {});
          })
          .catch((error) => {});
      },
    });

    this.props.signInModal();
  };

  render() {
    return (
      <div>
        <Header
          page="bag"
          headerTitle={this.props.headerTitle}
          customerIsGuest={this.props.data.customerIsGuest}
          isUserRegistered={this.props.data.isUserRegistered}
          path={this.props.data.continueShoppingUrl}
          customerId={Cookies.get("KK_CUSTOMER_ID")}
          customerEmail={this.props.data.customerEmail}
          signInLink={this.props.data.signInLink}
          registerLink={this.props.data.registerLink}
          itemCount={this.props.itemCount}
          customerIsLoggedIn={this.props.data.customerIsLoggedIn}
          isAdmin={this.props.data.isAdmin}
          signInLinkClick={this.signInLinkClick}
          createLinkClick={this.createLinkClick}
          signInPOC={this.signInPOC}
        />
        <GlobalStyle.BodyMainStyle className={this.props.data.bagSummaryFixed}>
          {this.props.data.bagLoader || this.props.data.profileLoader ? (
            <Loader />
          ) : (
            ""
          )}

          {this.props.data.isAdmin ? (
            <GlobalStyle.EmptyBagStyle className="admin-error">
              <img src={`${emptyBagIcon}`} />
              <h2>Can't proceed</h2>
              <p>
                Please sign-in with a personal (non-admin) account to complete
                checkout.
              </p>
              <a href="/" className="link-as-btn">
                Back to homepage
              </a>
            </GlobalStyle.EmptyBagStyle>
          ) : (
            <div className="section-main">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div>
                      <GlobalStyle.DesktopContinueShopping>
                        <ContinueShopping
                          page="bag"
                          path={this.props.data.continueShoppingUrl}
                        />
                      </GlobalStyle.DesktopContinueShopping>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container main-container">
                <div className="row">
                  {this.props.data.bagAPIErrors ? (
                    <div className="col-12 bag-summary-wrapper error">
                      {this.props.data.bagAPIErrorCode == "500" ? (
                        this.props.data.bagAPIErrorHTML ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: this.props.data.bagAPIErrorHTML,
                            }}
                          />
                        ) : (
                          <CheckoutPageError
                            pageErrorCode={this.props.data.bagAPIErrorCode}
                            pageErrorMessage={
                              this.props.data.bagAPIErrorMessage
                            }
                            refreshPage={this.props.refreshPage}
                          />
                        )
                      ) : (
                        <CheckoutPageError
                          pageErrorCode={this.props.data.bagAPIErrorCode}
                          pageErrorMessage={this.props.data.bagAPIErrorMessage}
                          refreshPage={this.props.refreshPage}
                        />
                      )}
                    </div>
                  ) : this.props.data.bagEmpty ? (
                    <GlobalStyle.EmptyBagStyle>
                      <img
                        src={`${emptyBagIcon}`}
                        style={{ width: "44px", height: "55px" }}
                      />
                      <p>Your bag is empty</p>
                      <a href={this.props.data.continueShoppingUrl}>
                        Continue shopping
                      </a>
                    </GlobalStyle.EmptyBagStyle>
                  ) : (
                    <div className="col-12 bag-summary-wrapper">
                      <div>
                        {this.props.data.isCartCustomMessage && !this.props.data.bagAPIErrors ? (
                          <CartMessaging
                            id="cart-messaging-desktop"
                            cartMessageDigitalAccessCodeList={this.props.data.cartMessageDigitalAccessCodeList}
                            cartMessageSecondHandIsbnList={this.props.data.cartMessageSecondHandIsbnList}
                            updatedReactivationCodeList={this.props.data.updatedReactivationCodeList}
                            cartMessageDigitalResourceList={this.props.data.cartMessageDigitalResourceList}
                            cartMessageFamilyNames={this.props.data.cartMessageFamilyNames}
                          />
                        ) : (
                          ""
                        )}
                        <BagSummary
                          currency={this.props.data.currency}
                          isAuRegion={this.props.data.isAuRegion}
                          orderSubTotal={this.props.data.orderSummaryTotal}
                          bagSummaryFixed={this.props.data.bagSummaryFixed}
                          customerIsGuest={this.props.data.customerIsGuest}
                          isUserRegistered={this.props.data.isUserRegistered}
                          signInLink={this.props.data.signInLink}
                          signinAndCheckoutLink={
                            this.props.data.signinAndCheckoutLink
                          }
                          registerLink={this.props.data.registerLink}
                          checkoutLink={this.props.data.checkoutLink}
                          guestCheckoutLink={this.props.data.guestCheckoutLink}
                          bagPagePath={this.props.data.bagPagePath}
                          checkoutPagePath={this.props.data.checkoutPagePath}
                          customerIsLoggedIn={
                            this.props.data.customerIsLoggedIn
                          }
                          signInLinkClick={this.signInLinkClick}
                          signInCheckoutLinkClick={this.signInCheckoutLinkClick}
                        />
                      </div>
                    </div>
                  )}
                  {}
                  <div className="col-12">
                    <div>
                      <div className="body-section body-bag">
                        {this.props.data.cart.map((item, index) => (
                          <BagItem
                            key={item.isbn}
                            bookImage={item.imagePath}
                            bookTitle={item.title}
                            bookAuthor={item.author}
                            bookPrice={item.price}
                            bookDiscountedPrice={item.discountedPrice}
                            discountCode={this.props.data.discountCode}
                            bookISBN={item.isbn}
                            bookType={item.type}
                            bookSubTotal={item.tempTotalPrice}
                            currency={this.props.data.currency}
                            changed={(event) =>
                              this.props.changed(
                                event,
                                item.isbn,
                                item.title,
                                item.price,
                                item.gtm.brand,
                                item.gtm.category,
                                item.subject,
                                item.learningStage,
                                item.qualification,
                                item.series,
                                item.gtm.variant,
                                item.quantity,
                                item.currencyCode,
                                item.discountedPrice,
                                index,
                              )
                            }
                            counter={item.tempQuantity}
                            openDeleteModal={(event) =>
                              this.props.isRemoveModalOpen(
                                event,
                                "bag",
                                item.isbn,
                                item.title,
                                item.price,
                                item.gtm.brand,
                                item.gtm.category,
                                item.subject,
                                item.learningStage,
                                item.qualification,
                                item.series,
                                item.gtm.variant,
                                item.quantity,
                                item.currencyCode,
                                item.discountedPrice,
                                index,
                              )
                            }
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </GlobalStyle.BodyMainStyle>
        <Modal
          show={this.props.data.isRemoveModalOpen}
          close={(event) => this.props.closeConfirmModal(event)}
        >
          <GlobalStyle.ModalHeadingStyle>
            <p className="modal-title">
              <GlobalStyle.ModalIconStyle src={warningIcon} />
              Remove item?
            </p>
          </GlobalStyle.ModalHeadingStyle>
          <p>Are you sure you want to remove this item from your bag?</p>
          <GlobalStyle.GhostBtnStyle
            onClick={(event) => this.props.closeConfirmModal(event)}
            ref={this.props.bagDeleteModalRef}
          >
            No, keep item
          </GlobalStyle.GhostBtnStyle>
          <GlobalStyle.MainBtnStyle
            onClick={(event) => this.props.deleteItem(event)}
          >
            Yes, remove
          </GlobalStyle.MainBtnStyle>
        </Modal>
        {/* Sign POC start */}
        {/* SAP CDC MODAL */}
        <Modal
          show={this.props.data.isSigninModalOpen}
          close={(event) => this.props.closeSigninModal(event)}
          classes="sign-in-modal"
        >
          <GlobalStyle.ModalHeadingStyle>
            <p className="modal-title"></p>
          </GlobalStyle.ModalHeadingStyle>

          <Loader classes="signin-modal-loader" />
          <div id="loginScreenDiv" className="gigya-signin-div"></div>
        </Modal>
        {/* <button
          onClick={this.signInPOC}
          style={{
            // display: "none",
            // background: "transparent",
            // color: "transparent",
            // border: "0",
            cursor: "pointer",
          }}
        >
          Sign In Modal
        </button> */}
        {/* Sign POC end */}
      </div>
    );
  }
}
export default Bag;
